import styled from "styled-components";
import { ServiceJ1SHeroSection } from "./ServiceJ1SHeroSection";
import { ServiceJ1SBackground } from "./ServiceJ1SBackground";
import { ServiceJ1SKeyBenefit } from "./ServiceJ1SKeyBenefit";
import { ServiceJ1SProvisionInLuxury } from "./ServiceJ1SProvisionInLuxury";
import { ServiceJ1SGetInTouchUs } from "./ServiceJ1SGetInTouchUs";
import { MainFooter } from "../../Footer/MainFooter";
import { useRef } from "react";

export function ServiceJ1SNormal({ pageContent = {} }) {
	const { content = {} } = pageContent;
	const refJ1SContactUs = useRef();
	const onClickContactUs = () => {
		//
		refJ1SContactUs.current.scrollIntoView({ behavior: "smooth" });
	};
	return (
		<HomepageContainer>
			<ServiceJ1SHeroSection banner={content?.banner} onClickContactUs={onClickContactUs} />
			<BodyContainer style={{ paddingBottom: 0 }}>
				<ServiceJ1SBackground what_is_jet_1_suites={content?.what_is_jet_1_suites} />
			</BodyContainer>
			<BodyContainer>
				<ServiceJ1SProvisionInLuxury a_provision_in_luxury={content?.a_provision_in_luxury} />
			</BodyContainer>
			{/* <BodyContainer> */}
			<ServiceJ1SKeyBenefit key_benefits={content?.key_benefits} />
			{/* </BodyContainer> */}
			<BodyContainer className="ra-j1s-get-in-touch" ref={refJ1SContactUs}>
				<ServiceJ1SGetInTouchUs get_in_touch_with_us={content?.get_in_touch_with_us} />
			</BodyContainer>
			<footer style={{ width: "100%" }}>
				<MainFooter />
			</footer>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	.ra-j1s-get-in-touch {
		padding-bottom: 120px;
	}
	@media (max-width: 767px) {
		.ra-j1s-get-in-touch {
			padding-bottom: 80px;
		}
	}
	@media (max-width: 576px) {
		.ra-j1s-get-in-touch {
			padding-bottom: 40px;
		}
	}
`;

const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 90px 80px 90px 80px;
	}
	@media (max-width: 767px) {
		padding: 60px 32px 60px 32px;
	}
	@media (max-width: 575px) {
		padding: 40px 20px 40px 20px;
	}
`;
